/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../ModalError/ModalError.css';
// import { urlPrefix } from '../../../clientConfig';

const initialState = {
  disabledButton: true,
};
class ModalHorarios extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }
  componentDidMount() {
    $('#ModalHorarios').modal({ backdrop: 'static', keyboard: false });
    $('.close').hide();
    this.configHora();
  }

  configHora() {
    const date = new Date();
    const editDate = moment(date).format('HH');
    const timeIn = [
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
    ];

    for (let i = 0; timeIn.length > i; i += 1) {
      if (timeIn[i] === editDate) {
        this.setState({ disabledButton: false });
        break;
      } else {
        this.setState({ disabledButton: true });
      }
    }
  }
  close = () => {
    $('#ModalHorarios').modal('hide');
  };

  render() {
    // const { hideLayout } = this.props;
    // const url = `${urlPrefix}/telemedicina/`;
    return (
      <div className="modal fade" id="ModalHorarios">
        <div className="modal-dialog" style={{ minWidth: '700px' }}>
          <div className={`${s.modalContent} modal-content`}>
            <div className={`${s.modalBody} modal-body`}>
              <div className="row">
                <div className="col-sm-12" style={{ textAlign: 'center' }}>
                  <p
                    style={{
                      fontWeight: '700',
                      color: '#e4002b',
                      fontSize: '18px',
                    }}
                  >
                    IMPORTANTE
                  </p>
                  <p style={{ padding: '10px', marginBottom: '0' }}>
                    Este servicio está disponible todos los días de 8 a 20 hs.
                  </p>
                  <p style={{ padding: '0px 4em 0px 4em' }}>
                    Rercordá que también podés acceder desde tu celular
                    utilizando nuestra app
                    <span style={{ color: '#e4002b', fontWeight: 'bold' }}>
                      {' '}
                      Swiss Medical Mobile
                    </span>
                  </p>
                  <p
                    style={{
                      paddingLeft: '30px',
                      paddingRight: '30px',
                      marginBottom: '10px',
                    }}
                  >
                    Si tu consulta es por una urgencia, por favor comunicate al
                    0800-777-7800.
                  </p>
                </div>
              </div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                // role="button"
                type="button"
                styling="link"
                tabIndex={0}
                className={`btn btn-default`}
                disabled={this.state.disabledButton}
                style={{
                  color: '#fff',
                  fontSize: '14px',
                  backgroundColor: '#e4002b',
                  cursor: 'pointer',
                  borderRadius: '.25rem',
                  fontFamily: 'Roboto, Medium, sans-serif',
                  fontWeight: 'bold',
                }}
                onClick={() => this.close()}
              >
                Ingresar a E-Consulta
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hideLayout: state.auth.hideLayout,
});

export default connect(mapStateToProps, null)(withStyles(s)(ModalHorarios));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalHorarios/ModalHorarios.js